"use client";

import { Mark, mergeAttributes } from '@tiptap/core';

export interface ChangeMarkOptions {
  HTMLAttributes: Record<string, any>;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    changeMark: {
      setChangeMark: (attrs: { id: string; type: 'insert' | 'delete' }) => ReturnType;
      unsetChangeMark: () => ReturnType;
    }
  }
}

const ChangeMark = Mark.create<ChangeMarkOptions>({
  name: 'changeMark',

  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: element => element.getAttribute('data-change-id'),
        renderHTML: attributes => {
          if (!attributes.id) return {};
          return { 'data-change-id': attributes.id };
        },
      },
      type: {
        default: 'insert',
        parseHTML: element => element.getAttribute('data-change-type') || 'insert',
        renderHTML: attributes => {
          return { 'data-change-type': attributes.type || 'insert' };
        },
      },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-change-id]' }];
  },

  renderHTML({ HTMLAttributes }) {
    const classes = ['mw-change', HTMLAttributes['data-change-type'] === 'delete' ? 'mw-change-delete' : 'mw-change-insert'];
    return [
      'span',
      mergeAttributes(HTMLAttributes, { class: classes.join(' ') }),
      0
    ];
  },

  addCommands() {
    return {
      setChangeMark:
        attrs =>
        ({ commands }) => {
          return commands.setMark(this.name, attrs);
        },
      unsetChangeMark:
        () =>
        ({ commands }) => {
          return commands.unsetMark(this.name);
        },
    };
  },
});

export default ChangeMark;